module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.b279b074.eot";